import styles from './BulletPoints.module.css';
import { BulletPointsResultCard } from '../BulletPointsResultCard';
import { BulletPointsList } from '../BulletPointsList';

type BulletPointsProps = {
  resultText: string;
  bulletPoints: string[];
};

export const BulletPoints = ({ resultText, bulletPoints }: BulletPointsProps) => {
  return (
    <div className={styles.bulletPointsLayout}>
      <div className={styles.bulletPointsContainer}>
        <h4 className={styles.bulletPointsHeader}>Key Features</h4>
        <BulletPointsList bulletPoints={bulletPoints} />
      </div>
      <BulletPointsResultCard text={resultText} />
    </div>
  );
};
